// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fe","advertDetailService__price":"c-o_ff"};